import { render, staticRenderFns } from "./CategoryPathsViewer.vue?vue&type=template&id=1c76db56&scoped=true"
import script from "./CategoryPathsViewer.vue?vue&type=script&lang=ts"
export * from "./CategoryPathsViewer.vue?vue&type=script&lang=ts"
import style0 from "./CategoryPathsViewer.vue?vue&type=style&index=0&id=1c76db56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c76db56",
  null
  
)

export default component.exports